import { DistrictSelect } from '~/pages/district/components/district-select';
import { useFilterForm } from '~/hooks/useFilterForm';
import { Table } from '~/components/Table/Table';
import { querySchema } from './query-schema';
import { Input } from '~/components/Input';

export function ClubListFilters() {
  const { register } = useFilterForm(querySchema.parse);

  return (
    <Table.Bar>
      <Table.Search {...register('search')} placeholder="Sök på förening..." aria-label="Sök" />

      <Table.Filter>
        <Table.FilterSection label="Distrikt">
          <DistrictSelect {...register('district_id')} />
        </Table.FilterSection>

        <Table.FilterSection label="Visa?">
          <Input.Select
            aria-label="Visa?"
            options={[
              ['Visa alla', 'ALL'],
              ['Endast aktiva', 'ACTIVE'],
            ]}
            {...register('state')}
          />
        </Table.FilterSection>
      </Table.Filter>
    </Table.Bar>
  );
}
